import { render } from "./NotificationPageSkeleton.vue?vue&type=template&id=17562dc7&ts=true"
import script from "./NotificationPageSkeleton.vue?vue&type=script&lang=ts"
export * from "./NotificationPageSkeleton.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__